/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
/* eslint-disable spire/fenced-imports */
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { CategoryDetailsPageContext } from "@NA/Overrides/Pages/CategoryDetailsPage";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
    noSearchResultsStyle?: GridItemProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    noSearchResultsStyle: {
        width: 12,
    },
    container: {
        gap: 20,
        css: css`
            @media (min-width: 768px) and (max-width: 1079px) {
                max-width: 768px;
                z-index:1;
            }
            @media (min-width: 576px) and (max-width: 767px) {
                max-width: 576px;
                z-index:1;
            }
            @media (min-width: 375px) and (max-width: 575px) {
                max-width: 575px;
                z-index:1;
            }
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 12, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        max-width: 256px !important;
                        label,
                        a,
                        span {
                            font-size: 14px !important;
                        }
                    `,
                ])}
        `,
    },
    leftColumnTableViewGridItem: {
        width: [12, 12, 0, 0, 0],
        css: css`
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        width: calc(100% - 256px) !important;
                        max-width: calc(100% - 256px) !important;
                        flex-basis: unset !important;
                    `,
                ])}
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 9, 9],
        css: css`
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        width: calc(100% - 256px) !important;
                        max-width: calc(100% - 256px) !important;
                        flex-basis: unset !important;
                    `,
                ])}
        `,
    },
    rightColumnTableViewGridItem: {
        width: 12,
    },
};

const styles = columnsStyles;

const CoveoProductListColumns: FC<Props> = ({ id, view }) => {
    const leftColumnGridItemStyle = view === "Table" ? styles.leftColumnTableViewGridItem : styles.leftColumnGridItem;
    const rightColumnGridItemStyle = view === "Table" ? styles.rightColumnTableViewGridItem : styles.rightColumnGridItem;

    return (
        <GridContainer {...styles.container}>
            <GridItem {...leftColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>

            <GridItem {...rightColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CoveoProductListColumns),
    definition: {
        group: "Product List",
        displayName: "Coveo Columns",
        allowedContexts: [ProductListPageContext, CategoryDetailsPageContext],
    },
};

export default widgetModule;
